module.exports = __webpack_public_path__ + "img/second.4c5ceb1a.png";